
// 本地缓存
export const setPrimaryColor = (color) => {
  return localStorage.setItem('primaryColorCache', color)
}
export const getPrimaryColor = () => {
  return localStorage.getItem('primaryColorCache')
}
export const setCreateProjectsFormCache = (obj) => {
  return localStorage.setItem('setCreateProjectsForm', obj)
}
export const getCreateProjectsFormCache = (obj) => {
  return localStorage.getItem('setCreateProjectsForm', obj)
}
export const setExperimentFormValue = (obj) => {
  return localStorage.setItem('experimentFormValueCache', obj)
}
export const getExperimentFormValue = () => {
  return localStorage.getItem('experimentFormValueCache')
}
export const setExperimentActiveIndex = (index) => {
  return localStorage.setItem('experimentActiveIndex', index)
}
export const getExperimentActiveIndex = () => {
  return localStorage.getItem('experimentActiveIndex')
}
/* 缓存createSingleSam每个页面点击done保存的数据 */
export const setSampleTypeListCache = (list) => {
  return localStorage.setItem('sampleTypeListCache', list)
}
export const getSampleTypeListCache = () => {
  return localStorage.getItem('sampleTypeListCache')
}
export const setTargetGenesButtonCache = (list) => {
  return localStorage.setItem('targetGenesListCache', list)
}
export const getTargetGenesButtonCache = () => {
  return localStorage.getItem('targetGenesListCache')
}
export const setSampleTreatmentButtonCache = (list) => {
  return localStorage.setItem('sampleTreatmentListCache', list)
}
export const getSampleTreatmentButtonCache = () => {
  return localStorage.getItem('sampleTreatmentListCache')
}
// 登录信息缓存
export const setUserInfos = (params) => {
  return localStorage.setItem('userInfos', params)
}
export const getUserInfos = () => {
  return localStorage.getItem('userInfos')
}
export const removeUserInfos = () => {
  return localStorage.removeItem('userInfos')
}
// reset
export const setResetUserInfos = (params) => {
  return localStorage.setItem('resetUserInfos', params)
}
export const getResetUserInfos = () => {
  return localStorage.getItem('resetUserInfos')
}
export const removeResetUserInfos = () => {
  return localStorage.removeItem('resetUserInfos')
}
// ins_exp_id_list
export const setInsExpIdList = (list) => {
  return localStorage.setItem('InsExpIdList', list)
}
export const getInsExpIdList = () => {
  return localStorage.getItem('InsExpIdList')
}
export const removeInsExpIdList = () => {
  return localStorage.removeItem('InsExpIdList')
}
// db_exp_id_list
export const setDBExpIdList = (list) => {
  return localStorage.setItem('DBExpIdList', list)
}
export const getDBExpIdList = () => {
  return localStorage.getItem('DBExpIdList')
}
export const removeDBExpIdList = () => {
  return localStorage.removeItem('DBExpIdList')
}



// WEBPACK FOOTER //
// ./src/utils/cache.js